"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Control = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = require("react-select");

var _useStyles = require("../../../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cd293f4a8 .cfd35ba4d{transition:flex-grow var(--animation-timing-def) ease;flex-grow:0}.cd293f4a8:hover .cfd35ba4d{flex-grow:1}.c9636df5d{margin-left:.125rem;margin-right:.125rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;box-sizing:border-box}.c3a4facaf{font-size:.875rem;font-weight:400;line-height:1rem;color:var(--color-flomni-gray-90)}.c362beea4{font-size:1rem;font-weight:400;line-height:1.125rem;color:var(--color-flomni-blue-70)}.cbf9c3c37{display:none}");
var styles = {
  hoverContainer: 'cd293f4a8',
  valueContainer: 'cfd35ba4d',
  value: 'c9636df5d',
  '--view-usual': 'c3a4facaf',
  '--view-tall': 'c362beea4',
  '--invisible': 'cbf9c3c37'
};
var AControl = _reactSelect.components.Control;

var Control = function Control(props) {
  // eslint-disable-next-line
  var children = props.children,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var selectProps = rest.selectProps,
      menuIsOpen = rest.menuIsOpen;
  var bg = selectProps.bg;
  var cn = (0, _useStyles.useStyles)(styles, {});
  var childrenArray = (0, _react.useMemo)(function () {
    return _react.Children.toArray(children).map(function (item) {
      return /*#__PURE__*/(0, _react.cloneElement)(item, {
        menuIsOpen: menuIsOpen
      });
    });
  }, [children, menuIsOpen]);
  return /*#__PURE__*/_react.default.createElement(AControl, (0, _extends2.default)({
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, cn.hoverContainer, bg === 'transparent'))
  }, rest), childrenArray);
};

exports.Control = Control;